import React from 'react';
import { Row, Col, Grid, Image } from 'react-bootstrap';
import circle from '../static/circle.svg';
import ChapterStatus from './ChapterStatus';

const VerticalBar = () => {
  return (
    <Row>
      <Col xs={1} xsOffset={6} className='vertical_bar'></Col>
    </Row>
  );
};

const PeriodCricle = () => {
  return (
    <div className='text-center'>
      <Image
        className='end_circle text-center'
        style={{ width: '35px' }}
        src={circle}
        circle
      />
    </div>
  );
};

const ChapterTable = ({ chapters }) => {
  return (
    <Grid className='main_content'>
      <Row>
        {chapters.map((chapter, i) => (
          <div key={i}>
            <Col
              className='weekly_content'
              xs={12}
              md={10}
              mdOffset={1}
              lg={8}
              lgOffset={2}
            >
              <div className='week_title'>
                <span>
                  Chapter {chapter.order}: {chapter.topic}
                </span>
              </div>
              <div className='progress_status'>
                <ChapterStatus
                  details={chapter.details}
                  chapterNumber={chapter.order}
                />
              </div>
            </Col>
            <VerticalBar />
          </div>
        ))}
        <PeriodCricle />
      </Row>
    </Grid>
  );
};

export default ChapterTable;



// WEBPACK FOOTER //
// ./src/components/ChapterTable.js